import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookDashboardReportsTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          reports: {},
          flight_legs_list: [],
          users_list: [],
          bases_list: [],
          approvals: [],
        };
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      handleToggleChange (name, event) {
        var change = {};
        if (event.target.checked === true) {
          var value = 1;
        } else {
          var value = 0;
        }
        change[name] = value;
        this.setState(change);
      }

      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            loaded: 1,
          });
        }

        if(typeof newProps.reports !== 'undefined' && newProps.reports !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            reports: newProps.reports,
          });
        }

        if(typeof newProps.flight_legs_list !== 'undefined' && newProps.flight_legs_list !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            flight_legs_list: newProps.flight_legs_list,
          });
        }

        if(typeof newProps.users_list !== 'undefined' && newProps.users_list !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            users_list: newProps.users_list,
          });
        }

        if(typeof newProps.bases_list !== 'undefined' && newProps.bases_list !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            bases_list: newProps.bases_list,
          });
        }

        if(typeof newProps.approvals[8] !== 'undefined' && newProps.approvals[8] !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            approvals: newProps.approvals[8],
          });
        }
      }
    
    
      render() {
        var self = this;
        return (
      <div>
      <RequestApi ref={'request_api'} />
        <h3 className="page-title pull-left">Reports of Crew or Maintenance</h3>
        <div className="clearfix"></div>
        <hr/>
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <caption>Reports</caption>
            <thead>
              <tr>
                <th>Item</th>
                <th>Flight Leg</th>
                <th>Location</th>
                <th>Detected By</th>
                <th>Detected At</th>
                <th>System</th>
                <th>Next Mnt Type</th>
                <th>Hrs Next Mnt</th>
                <th>Description</th>
                <th>Approved By</th>
                <th>Approved At</th>
              </tr>
            </thead>
            <tbody id="reports">
            {Object.keys(self.state.reports).map(function(k) {
              var report = self.state.reports[k];
              return(
              <tr className="text-center" key={report.id}>
                <td>{report.item}</td>
                <td>{report.leg}</td>
                <td>{report.location_name}</td>
                <td>{report.user_name}</td>
                <td>{report.date_str}</td>
                <td>{report.system_name}</td>
                <td>{report.next_maintenance_intervention_type_name}</td>
                <td>{report.flight_hours_next_maintenance_intervention_str}</td>
                <td>{report.description}</td>
                <td>{report.approval_user_name}</td>
                <td>{report.approval_date_str}</td>
              </tr>
              );
            })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default AircraftLogbookDashboardReportsTab;


// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookDashboardReportsTab.js